<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div>
  <popup-select
      id="hospital-select"
      ref="popupSelect"
      v-model="selectedHospital"
      :custom="true"
      :title="'选择医院'"
      :forced="forced"
  >
    <slot>
      <ul class="list list-select">
        <li class="list-item">
          <div
              id="hospitalSelect-div-hospitalName"
              class="hospital arr-row ellipsis"
          >
            {{ selectedHospital.hospitalName }}
          </div>
        </li>
      </ul>
    </slot>
    <div id="hospitalSelect-tree" slot="custom">
      <ul class="list">
        <li
            class="list-item arr-row"
            v-for="hospital in hospitalList"
            :key="hospital.hospitalId"
            :id="'hospitalSelect-li-hospital-' + hospital.hospitalId"
            @click="select(hospital)"
        >
          <div class="hospital-info">
            <!-- 添加空值判断和默认处理 -->
            <div
                class="logo"
                :style="{
                  backgroundImage: hospital.hospitalLogo
                    ? `url(${hospital.hospitalLogo})`
                    : 'url(../../../static/img/hos-def-logo.png)'
                }"
            ></div>
            <div class="info">
              <!-- 添加空值回退 -->
              <p class="f-large f-normal ellipsis">
                {{ hospital.hospitalName || '未知医院' }}
              </p>
              <p class="f-small f-dark-gray ellipsis">
                {{ hospital.hospitalAddr || '地址信息未提供' }}
              </p>
            </div>
          </div>
          <!-- 小程序入口医院：微信内点击透明覆盖层直接拉起小程序 -->
          <!-- 注意：wxtag-template 内不支持 % 宽高，必须用固定 px（参考 AppletIconMenu） -->
          <div
            v-if="hospital.weapp"
            class="weapp-launch-wrap"
          >
            <wx-open-launch-weapp
                    v-if="hospital.weapp"
                    class="weapp-launch-layer"
                    :appid="hospital.weapp.appid"
                    :username="hospital.weapp.username"
                    :path="hospital.weapp.path"
                    @launch="handleWeappLaunch"
                    @error="handleWeappError"
            >
              <script type="text/wxtag-template">
                <style>
                  .weapp-launch-btn {
                    width: 750px;
                    height: 100px;
                    border: none;
                    background: #fff;
                  }
                </style>
                <div class="weapp-launch-btn"></div>
              </script>
            </wx-open-launch-weapp>
          </div>

        </li>
      </ul>
      <no-record
          :condition="hospitalList.length === 0"
          tips="抱歉，暂无医院列表信息"
      ></no-record>
  </popup-select>
  </div>
</template>

<script>
import NoRecord from 'NoRecord'
import basicsMixinx from 'mixins/basics'
export default {
  mixins: [basicsMixinx],
  components: {
    NoRecord
  },
  created() {
  },
  props: {
    noSelectedOpen: {
      type: Boolean,
      default: true
    },
    alwaysOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hospitalList: [
        {
          hospitalAddr: "四川省成都市彭州市致和镇南三环路二段255号",
          hospitalId: "1003",
          hospitalLogo: "http://pzwjw-imts.hngwmt.com/hosinfo/1003/1003.png",
          hospitalName: "彭州市人民医院互联网医院",
          // 人民医院互联网医院已切换为微信小程序，通过 wx-open-launch-weapp 拉起
          weapp: {
            appid: 'wx2ea8fa97460f447e',
            username: 'gh_3ea903f2a818',
            path: 'pages/xnIndex/index'
          }
        },{
          hospitalAddr: "彭州市南大街396号",
          hospitalId: "1004",
          hospitalLogo: "http://pzwjw-imts.hngwmt.com/hosinfo/1004/1004.jpg",
          hospitalName: "彭州市中医医院互联网医院",
          hospitalUrl:'https://hlwyyv2.cdjyt.com.cn/hlwyyweb/#/pages/hospital/hospital?query=%7B%22orgId%22%3A503322,%22regWayCode%22%3A%22HLW_503322%22,%22home%22%3Atrue%7D'
        }
      ],
      selectedHospital: {
        hospitalAddr:  '',
        hospitalName: '',
        hospitalId: '',
        hospitalUrl: '',
        hospitalLogo: ''
      },
      forced: this.alwaysOpen || this.noSelectedOpen
    }
  },
  methods: {
    select(v) {
        if (v.weapp) {
            return
        }
        window.location.href = v.hospitalUrl;
    },
    handleWeappLaunch(e) {
        console.log('launch weapp', e)
    },
    handleWeappError(e) {
        console.log('launch weapp fail', e.detail)
    }
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.list-select {
  .list-item {
    .hospital {
      background: url(../../../static/img/hospital-icon.png) left center no-repeat;
      background-size: auto 100%;
    }
  }
}
.list {
  .list-item {
    position: relative;
    &.def {
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    &.last {
      padding-right: 0.5rem !important;
      color: $main-style-color;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .continue {
        padding-right: 0.5rem;
        color: $main-style-color;
        background: url(../../../static/img/more-right-blue.png) right center
        no-repeat;
        background-size: 0.2rem 0.4rem;
      }
    }
  }
}
.list-header {
  background-color: #e1edfb;
}
.header {
  padding-top: 0.13rem;
  padding-bottom: 0.13rem;
  color: #999;
  font-size: 0.65rem !important;
  background-color: #eff2f5;
}
.border-none {
  li:first-child,
  li:last-child {
    border-bottom: none;
  }
}
.hospital-info {
  @include display-flex();
  @include align-items(center);
  .logo {
    width: 1.5rem;
    height: 1.5rem;
    background-image: url(../../../static/img/hos-def-logo.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .info {
    @include flex(1);
    @include ellipsis();
    width: 1px;
    padding-left: 10px;
  }
}
/* 覆盖整行；模板内按钮用固定 px，超出部分由 overflow 裁切 */
.weapp-launch-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: #fff;
  overflow: hidden;
}
.weapp-launch-layer {
  display: block;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// internetHospital.vue?759e6db1